// src/components/ChatPanel.jsx
import React from 'react';

function ChatPanel() {
  return (
    <div className="pane-right-section">
      <h4>Chat</h4>
      <p>Chat feature will be available here.</p>
    </div>
  );
}

export default ChatPanel;